import './child-image.scss';

import { Either } from '@sola/schema/dotcom/helpers.ts';

import {
  ChildImageVariantEnum,
  getChildImageUrl,
} from '../../utils/child-image.ts';
import { cn } from '../../utils/helpers.ts';

// TODO: Jeff Boutwell changed this last week - but it throws an error because no width is specified...
// import { Image } from '../image/image.tsx';

export type ChildImageProps = {
  variant?: ChildImageVariantEnum;
  // could receive a child object instead...?
  childImageUrl?: string;
  width?: number;
  // height?: number; // height would be conditional I'd expect
  className?: string;
} & Either<{ name: string }, { alt: string }>;

export const ChildImage: React.FC<ChildImageProps> = ({
  alt,
  childImageUrl,
  name,
  variant = ChildImageVariantEnum.Full,
  width,
  // height,
  className,
}) => {
  const imageUrl = getChildImageUrl(childImageUrl || '', variant, width);
  if (!imageUrl) {
    return null;
  }

  return (
    <img
      className={cn(`ChildImage`, className, {
        'ChildImage--circle': variant === ChildImageVariantEnum.Circle,
      })}
      src={imageUrl}
      // @TODO: Translate string.
      alt={alt || `Photo of ${name}`}
      width={width}
      crossOrigin="anonymous"
    />
  );
};
